import cx from 'classnames';
import { Anchor } from 'components/admin/ui';
import { Pill, Tooltip } from 'components/ui';
import { ArrowRight, BookOpen01, Grid01 } from 'ethena-icons';
import _ from 'lodash';
import { MouseEvent } from 'react';
import css from './ModuleAttributes.module.scss';

interface IModuleAttributesProps {
  belongsToModuleNames?: string[];
  includedNudgeGroupNames?: string[];
  isContinuousLearning?: boolean;
  isCustomContent: boolean;
}

export const ModuleAttributes = ({
  belongsToModuleNames,
  includedNudgeGroupNames,
  isContinuousLearning,
  isCustomContent,
}: IModuleAttributesProps) => {
  const children = _.compact([
    isContinuousLearning && (
      <span className={css.attribute} key="continuous-learning">
        <BookOpen01 /> Continuous Learning
      </span>
    ),

    !_.isEmpty(belongsToModuleNames) && (
      <span className={cx(css.attribute, css.alignIconTop)} key="belongs-to">
        <ArrowRight /> Included in {_.join(belongsToModuleNames, ', ')}
      </span>
    ),

    _.size(includedNudgeGroupNames) > 1 && (
      <Tooltip
        key="included"
        placement="right"
        title={
          <ul>
            {_.map(includedNudgeGroupNames, (name, i) => (
              <div className="text-left" key={i}>
                {name}
              </div>
            ))}
          </ul>
        }
      >
        <Anchor
          className={css.attribute}
          href="#"
          onClick={(ev: MouseEvent) => ev.preventDefault()}
        >
          <Grid01 /> Multiple Modules
        </Anchor>
      </Tooltip>
    ),

    isCustomContent && (
      <Pill color="yellow" key="custom-content">
        Custom Content
      </Pill>
    ),
  ]);

  return _.isEmpty(children) ? null : (
    <div className={css.attributes}>{children}</div>
  );
};
